import { ResourceName } from '../resource-name';

export const DeepgramGate = {
  resource: ResourceName.deepgram,
  actions: {
    getTempApiKeyForSession: 'get-temp-api-key-for-session',
  },
};

export type DeepgramGateTypes = {
  getTempApiKeyForSession: {
    request: GetTempApiKeyForSessionRequest;
    response: string;
  };
};

export interface GetTempApiKeyForSessionRequest {
  sessionId: string;
}
